module.exports = __webpack_public_path__ + "static/media/cldc2009_program.74d6d14e.pdf";